import { memo } from "react";
import { styled } from "styled-components";

import { SourceLabel } from "common/components";
import { ListItemWrapper, type ListItemWrapperProps } from "common/components/lists/ListItemWrapper";
import { ListImage, ListLink } from "common/components/lists/ListLink";
import type { ListItemType } from "common/components/lists/types";
import { StyledContent, StyledTitle } from "domains/knowledgeFeed/components/shared";
import type { Source } from "entities/knowledge/types";

const StyledImage = styled(ListImage)`
  display: flex;
  flex-shrink: 0;
  width: 100px;
  height: 60px;
  border-radius: 4px;
  margin-right: 15px;
`;

const StyledLink = styled(ListLink)`
  text-decoration: none;
  display: flex;
`;

type InteractiveDataListItemProps = ListItemWrapperProps & {
  title: string;
  imageUrl?: string;
  link: string;
  source: Source;
  timestamp: number;
  type?: ListItemType;
  onClick?: () => void;
};

export const InteractiveDataListItem = memo(
  ({ title, imageUrl, link, source, timestamp, ...listItemWrapperProps }: InteractiveDataListItemProps) => (
    <ListItemWrapper {...listItemWrapperProps}>
      <StyledLink to={link}>
        <StyledImage src={imageUrl} />
        <StyledContent>
          <StyledTitle>{title}</StyledTitle>
          {source && <SourceLabel source={source} date={timestamp} type="small" />}
        </StyledContent>
      </StyledLink>
    </ListItemWrapper>
  ),
);

InteractiveDataListItem.displayName = "InteractiveDataListItem";
